(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/menu.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/menu.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const usedPitches = [];
const _svs$app$ReactRouter = svs.app.ReactRouter,
  withRouter = _svs$app$ReactRouter.withRouter,
  matchPath = _svs$app$ReactRouter.matchPath;
const _React = React,
  useEffect = _React.useEffect;
const _svs$tickets$play$uti = svs.tickets.play.utils.constants,
  PICK_PATH = _svs$tickets$play$uti.PICK_PATH,
  PLAY_PATH = _svs$tickets$play$uti.PLAY_PATH,
  MY_GAMING_PATH = _svs$tickets$play$uti.MY_GAMING_PATH;
const availableTickets = svs.tickets.data.moduleConfig.availableTickets;
const Menu = _ref => {
  var _currentProduct$ticke, _ticketType;
  let history = _ref.history,
    appTimeline = _ref.appTimeline,
    products = _ref.products;
  const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
    ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
    BallItem = _svs$ui$ReactItemsMen.BallItem;
  const BubbleUsp = svs.tickets.play.components.BubbleUsp;
  const branding = svs.tickets.data.templateConfig.branding;
  const Brand = svs.ui.ReactBrand;
  const ticketInfoMatch = matchPath(history.location.pathname, {
    path: [PICK_PATH, PLAY_PATH]
  });
  const pickMatch = matchPath(history.location.pathname, {
    path: PICK_PATH
  });
  const myGamingMatch = matchPath(history.location.pathname, {
    path: MY_GAMING_PATH
  });
  let ticketType;
  if (ticketInfoMatch) {
    ticketType = ticketInfoMatch.params.ticketType;
  } else {
    ticketType = svs.tickets.play.utils.utils.getTicketTypeFromWager(myGamingMatch.params.wagerId).ticketType;
  }
  const isTrissBranding = branding === 'triss';
  const menuBg = isTrissBranding ? 'bg-triss' : 'bg-header-skrapspel';
  const currentProduct = _.find(products, product => {
    var _product$alternativeU;
    return product.type.toLowerCase() === ticketType.toLowerCase() || (product === null || product === void 0 || (_product$alternativeU = product.alternativeUrl) === null || _product$alternativeU === void 0 ? void 0 : _product$alternativeU.toLowerCase()) === ticketType.toLowerCase();
  });
  const ticketPitchImage = currentProduct === null || currentProduct === void 0 || (_currentProduct$ticke = currentProduct.ticketPitch) === null || _currentProduct$ticke === void 0 ? void 0 : _currentProduct$ticke.image;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    shouldPlayAnimation = _React$useState2[0],
    setShouldPlayAnimation = _React$useState2[1];
  function itemClick(selected) {
    var _selected$alternative;
    const productTitle = _.find(products, product => product.type === selected.type);
    document.title = productTitle && productTitle.title || '';
    history.push("/valja/".concat(((_selected$alternative = selected.alternativeUrl) === null || _selected$alternative === void 0 ? void 0 : _selected$alternative.toLowerCase()) || selected.type.toLowerCase()));
  }
  const productInfo = availableTickets.find(ticket => {
    var _ticket$alternativeUr;
    return ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === ticketType.toLowerCase();
  }) || availableTickets.find(ticket => ticket.type.toLowerCase() === ticketType.toLowerCase());
  useEffect(() => {
    if (!ticketPitchImage || usedPitches.includes(ticketPitchImage)) {
      setTimeout(() => {
        var _appTimeline$isActive;
        if (!(appTimeline !== null && appTimeline !== void 0 && (_appTimeline$isActive = appTimeline.isActive) !== null && _appTimeline$isActive !== void 0 && _appTimeline$isActive.call(appTimeline))) {
          appTimeline.pause();
          appTimeline.seek('gameReady');
        }
      }, 0);
    }
    usedPitches.push(ticketPitchImage);
  }, [ticketType]);
  if (ticketType && productInfo !== null && productInfo !== void 0 && productInfo.alternativeUrl && productInfo.alternativeUrl.toLowerCase() !== ((_ticketType = ticketType) === null || _ticketType === void 0 ? void 0 : _ticketType.toLowerCase())) {
    const newPath = location.pathname.split('/').slice(2) 
    .join('/').split(ticketType) 
    .join(productInfo.alternativeUrl);
    if (!location.pathname.includes("/".concat(newPath).concat(location.search))) {
      history.replace("/".concat(newPath).concat(location.search));
    }
  }
  function itemPitch() {
    if (ticketPitchImage) {
      setShouldPlayAnimation(!shouldPlayAnimation);
    }
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-1 padding-bottom-1 relative games-navigation-wrapper ".concat(menuBg)
  }, React.createElement(ItemsMenu, {
    branding: branding,
    centered: true
  }, products.map(product => {
    var _product$alternativeU2;
    const selected = product.alternativeUrl && ticketType.toLowerCase() === ((_product$alternativeU2 = product.alternativeUrl) === null || _product$alternativeU2 === void 0 ? void 0 : _product$alternativeU2.toLowerCase()) || ticketType.toLowerCase() === product.type.toLowerCase();
    return React.createElement(BallItem, {
      borderOnly: true,
      key: "ball-item-".concat(product.type),
      label: product.name,
      onClick: e => {
        var _e$currentTarget$quer;
        svs.ticketgames.ticketUtility.utils.tracking.trackTicketsBallMenuClick({
          brand: branding,
          product: ((_e$currentTarget$quer = e.currentTarget.querySelector('.items-menu-label')) === null || _e$currentTarget$quer === void 0 ? void 0 : _e$currentTarget$quer.innerText) || ''
        });
        if (selected && pickMatch) {
          itemPitch();
        } else {
          itemClick(product);
        }
      },
      selected: selected
    }, React.createElement(Brand, {
      brand: product.icon,
      className: isTrissBranding ? 'bg-triss-200' : undefined,
      square: !isTrissBranding
    }));
  }))), pickMatch && ticketPitchImage && React.createElement(BubbleUsp, {
    appTimeline: appTimeline,
    isFirstTime: !usedPitches.includes(ticketPitchImage),
    key: ticketType,
    onAnimationEnd: () => {
      setShouldPlayAnimation(false);
    },
    shouldPlayAnimation: shouldPlayAnimation,
    ticketPitchImage: ticketPitchImage
  }));
};
setGlobal('svs.tickets.play.components.Menu', withRouter(Menu));

 })(window);